import { useEffect, useState } from "react";
import { Phone } from "lucide-react";

export default function CallNowFab() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="tel:6313723526"
      className={`fixed bottom-20 right-5 sm:bottom-24 sm:right-7 z-50 group inline-flex items-center gap-2 sm:gap-3 bg-brand-red hover:bg-brand-redDark text-white px-3 sm:pl-4 sm:pr-5 py-3 sm:py-3.5 font-heading tracking-wide border-2 border-brand-navy shadow-[5px_5px_0_#0A1128] hover:shadow-[8px_8px_0_#0A1128] hover:-translate-x-1 hover:-translate-y-1 transition-all ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      data-testid="call-now-fab"
      aria-label="Call McFly's Fuel Inc now at 631-372-3526"
    >
      <span className="relative flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center bg-brand-navy border-2 border-white rounded-full">
        <span className="absolute inset-0 rounded-full bg-brand-red opacity-75 animate-ping"></span>
        <Phone size={16} className="relative text-white" />
      </span>
      <span className="hidden sm:flex flex-col leading-none text-left">
        <span className="text-[10px] uppercase tracking-[0.2em] text-brand-gold">Call Now</span>
        <span className="font-heading text-base">631-372-3526</span>
      </span>
      <span className="sm:hidden font-heading text-sm">CALL</span>
    </a>
  );
}
